import { map } from "lodash";
// list: https://help.mixpanel.com/hc/en-us/articles/115004708186-What-is-the-difference-between-Event-Properties-Super-Properties-and-People-Properties-and-which-should-I-use-
const transformer = {
    email: "$email",
    isAdvisor: "Advisor",
    name: "$name",
    phone: "$phone",
    firstName: "$first_name",
    lastName: "$last_name",
    created: "$created",
    city: "$city",
    state: "$region",
    profileImageUrl: "$avatar",
    isAdmin: "Admin",
    advisorId: "123",
    advisorName: "Advisor Name",
    dateOfBirth: "01/01/2023",
};
export function convertProfileDetails(details) {
    return map(details, (val, key) => {
        if (key in transformer) {
            return [transformer[key], val];
        }
        else {
            return [key, val];
        }
    }).reduce((accum, [key, val]) => ({ ...accum, [key]: val }), {});
}
//# sourceMappingURL=mixpanel.js.map